{
  "name": "@myre/app-user-frontend",
  "version": "0.0.0",
  "type": "module",
  "myreSentryProjectName": "frontend-user",
  "sideEffects": false,
  "dependencies": {
    "@myre/app-am-generated": "workspace:*",
    "@myre/app-entity-generated": "workspace:*",
    "@myre/app-user-generated": "workspace:*",
    "@myre/common-api": "workspace:*",
    "@myre/common-conf": "workspace:*",
    "@myre/common-core": "workspace:*",
    "@myre/common-dates": "workspace:*",
    "@myre/common-i18n": "workspace:*",
    "@myre/common-logger": "workspace:*",
    "@myre/common-primitives": "workspace:*",
    "@myre/common-sheet": "workspace:*",
    "@myre/common-tag": "workspace:*",
    "@myre/domain-api-internal": "workspace:*",
    "@myre/domain-i18n-core": "workspace:*",
    "@myre/domain-i18n-wordings": "workspace:*",
    "@myre/domain-models": "workspace:*",
    "@myre/ui-domain-core": "workspace:*",
    "@myre/ui-domain-http": "workspace:*",
    "@myre/ui-primitive-components": "workspace:*",
    "@myre/ui-primitive-core": "workspace:*",
    "@myre/ui-primitive-forms": "workspace:*",
    "@myre/ui-primitive-layouts": "workspace:*",
    "@myre/ui-primitive-list-paginated": "workspace:*",
    "@myre/ui-primitive-modal": "workspace:*",
    "@myre/ui-primitive-multi-table": "workspace:*",
    "@myre/ui-primitive-navbar": "workspace:*",
    "@myre/ui-primitive-subbar": "workspace:*",
    "@myre/ui-primitive-tiles": "workspace:*",
    "@myre/ui-primitive-tooltip": "workspace:*",
    "@myre/ui-primitive-tree-table": "workspace:*"
  }
}
